module.exports = __webpack_public_path__ + "media/promo/velle/images/products/prod_4-cc96415dfd38ced105b5ab030e3f264b.png";